<template>
  <div v-cloak>
    <!-- 面包屑：Role and Access Maintain > R&R Tag Maintain -->
    <breadcrumb father="Role and Access Maintain" self="R&R Tag Maintain"></breadcrumb>

    <!-- 筛选卡片：左侧控件组 + 右侧按钮组 -->
    <div class="filter-card">
      <div class="filter-items">
        <div class="filter-item">
          <label class="filter-label">Role Tag</label>
          <el-select v-model="filterForm.roleTag" placeholder="全部" size="small" clearable filterable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options.ROLE_TAG" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">BU</label>
          <el-select v-model="filterForm.bu" placeholder="全部" size="small" clearable filterable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options.BU" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">Channel</label>
          <el-select v-model="filterForm.channel" placeholder="全部" size="small" clearable filterable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options.CHANNEL" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">Function Tag</label>
          <el-select v-model="filterForm.functionTag" placeholder="全部" size="small" clearable filterable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options.FUNCTION_TAG" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">Scenario</label>
          <el-select v-model="filterForm.scenario" placeholder="全部" size="small" clearable filterable style="width: 180px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in options.SCENARIO" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">Name En</label>
          <el-input
            v-model="filterForm.nameEn"
            placeholder="搜索..."
            size="small"
            prefix-icon="el-icon-search"
            clearable
            style="width: 180px"
          ></el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">Email</label>
          <el-input
            v-model="filterForm.email"
            placeholder="搜索..."
            size="small"
            prefix-icon="el-icon-search"
            clearable
            style="width: 180px"
          ></el-input>
        </div>
      </div>
      <div class="filter-btns">
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
      </div>
    </div>

    <!-- 表格卡片：工具栏 + 表格 + 分页 -->
    <div class="table-card">
      <div class="table-toolbar">
        <div class="toolbar-left">
          <span class="total-count">共 {{ total }} 条</span>
          <span v-if="selectedRows.length > 0" class="selected-count">已选 {{ selectedRows.length }} 条</span>
        </div>
        <div class="toolbar-btns">
          <el-button size="small" icon="el-icon-download" :loading="exportLoading" :disabled="tableLoading" @click="handleExport">导出</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" :disabled="tableLoading || selectedRows.length === 0" @click="handleDelete">删除</el-button>
          <el-button size="small" icon="el-icon-price-tag" :disabled="tableLoading" @click="openManualDialog">手动打标</el-button>
          <el-button size="small" icon="el-icon-tickets" :disabled="tableLoading" @click="openImportDialog">批量维护</el-button>
          <el-button v-permission="['', 'user-tag-maintenance-rule']" size="small" type="primary" icon="el-icon-setting" :disabled="tableLoading" @click="openRuleDialog">规则维护</el-button>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        ref="userTagTable"
        v-loading="tableLoading"
        :data="tableData"
        stripe
        :height="tabHeight"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" align="center" fixed="left" :selectable="checkSelectable"></el-table-column>
        <el-table-column prop="tagSource" label="Tag Source" min-width="110"></el-table-column>
        <el-table-column prop="roleTag" label="Role Tag" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bu" label="BU" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channel" label="Channel" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="functionTag" label="Function Tag" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scenario" label="Scenario" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="nameEn" label="Name En" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="Email" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bandLevel" label="Band Level" min-width="90"></el-table-column>
        <el-table-column prop="function" label="Function" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="organization" label="Organization" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="position" label="Position" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="banner" label="Banner" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="category" label="Category" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="cls-page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 手动打标弹窗 -->
    <el-dialog :visible.sync="manualDialogVisible" width="560px" :close-on-click-modal="false" :before-close="manualBeforeClose" @closed="resetManualForm">
      <div slot="title" class="manual-dialog-title">
        <div class="manual-title">手动打标</div>
        <div class="manual-subtitle">手动为指定用户配置标签信息</div>
      </div>
      <el-form ref="manualForm" :model="manualForm" :rules="manualRules" label-position="top" size="small">
        <el-form-item label="Email" prop="email">
          <el-input v-model="manualForm.email" placeholder="请输入用户 Email" clearable></el-input>
        </el-form-item>
        <el-form-item label="Role Tag" prop="roleTag">
          <el-select v-model="manualForm.roleTag" placeholder="请选择" filterable style="width: 100%">
            <el-option v-for="item in roleTagConfigOptions" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="BU">
              <el-select v-model="manualForm.bu" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in options.BU" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Channel">
              <el-select v-model="manualForm.channel" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in options.CHANNEL" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Function">
              <el-select v-model="manualForm.functionTag" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in options.FUNCTION_TAG" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Scenario">
              <el-select v-model="manualForm.scenario" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option v-for="item in options.SCENARIO" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" :disabled="manualLoading" @click="manualDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="manualLoading" @click="submitManual">确认提交</el-button>
      </span>
    </el-dialog>

    <!-- 批量维护（导入）弹窗 -->
    <el-dialog :visible.sync="importDialogVisible" width="840px" :close-on-click-modal="false" :before-close="importBeforeClose" @closed="resetImport">
      <div slot="title" class="manual-dialog-title">
        <div class="manual-title">批量维护</div>
        <div class="manual-subtitle">通过上传 Excel 文件批量更新人员标签记录</div>
      </div>

      <div class="import-steps">
        <!-- 步骤 1：下载模板 -->
        <div class="import-step">
          <span class="step-no">1</span>
          <div class="step-body">
            <div class="step-title">下载模板</div>
            <div class="step-desc">下载标准 Excel 模板，模板包含所需的列头信息。</div>
            <el-button type="primary" plain size="small" icon="el-icon-download" :loading="templateLoading" @click="handleTemplateDownload">下载模板</el-button>
          </div>
        </div>
        <!-- 步骤 2：填写数据 -->
        <div class="import-step">
          <span class="step-no">2</span>
          <div class="step-body">
            <div class="step-title">填写数据</div>
            <div class="step-desc">打开模板，逐行填写或修改人员信息。每行至少需填写 Tag 和 User Email 字段。</div>
          </div>
        </div>
        <!-- 步骤 3：上传文件 -->
        <div class="import-step">
          <span class="step-no">3</span>
          <div class="step-body">
            <div class="step-title">上传文件</div>
            <div class="step-desc">上传填写完成的文件，系统将按 User Email 匹配并更新对应记录。</div>
            <el-upload
              class="import-upload"
              :action="uploadUrl"
              :http-request="uploadFileRequest"
              :before-upload="beforeUpload"
              :show-file-list="false"
              :auto-upload="true"
              name="file"
              accept=".xlsx,.xls"
            >
              <el-button type="primary" size="small" icon="el-icon-upload2" :loading="uploading">选择文件上传</el-button>
            </el-upload>
            <div v-if="importFile.fileId" class="uploaded-file">
              <i class="el-icon-document"></i>
              <span :title="importFile.fileName">{{ importFile.fileName }}</span>
              <i class="el-icon-close" @click="resetImportFile"></i>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer">
        <el-button size="small" type="primary" :disabled="importLoading" @click="importDialogVisible = false">取消</el-button>
        <el-button v-if="importFile.fileId" size="small" type="primary" :loading="importLoading" @click="submitImport">导入</el-button>
      </span>
    </el-dialog>

    <!-- 规则维护弹窗 -->
    <el-dialog title="规则维护" custom-class="rule-dialog" :visible.sync="ruleDialogVisible" :close-on-click-modal="false" width="900px" @opened="fetchRules" @closed="ruleList = []">
      <el-alert
        type="warning"
        :closable="false"
        title="规则保存 / 启停 / 删除后不会立即生效"
        description="需等待定时任务（每天 5 次）执行后，才会反映到列表的标签数据。"
        style="margin-bottom: 16px"
      ></el-alert>
      <div class="action-right" style="margin-bottom: 12px">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openRuleForm()">新增规则</el-button>
      </div>
      <el-table v-loading="ruleLoading" :data="ruleList" border size="small" style="width: 100%">
        <el-table-column prop="ruleName" label="规则名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="roleTag" label="产出标签" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bu" label="BU" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channel" label="Channel" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="functionTag" label="Function Tag" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scenario" label="Scenario" min-width="90" show-overflow-tooltip></el-table-column>
        <el-table-column prop="enabled" label="启用" width="80" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.enabled"
              :active-value="1"
              :inactive-value="0"
              @change="(val) => toggleRule(scope.row, val)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createdBy" label="创建人" min-width="100"></el-table-column>
        <el-table-column label="操作" width="130" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openRuleForm(scope.row)">编辑</el-button>
            <el-button type="text" size="small" class="danger-text" @click="deleteRule(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 规则新增/编辑弹窗 -->
    <el-dialog custom-class="rule-dialog" :visible.sync="ruleFormVisible" :close-on-click-modal="false" width="760px" @opened="initSqlEditor" @closed="resetRuleForm">
      <div slot="title" class="manual-dialog-title">
        <div class="manual-title">{{ ruleEditMode ? '编辑规则' : '新增规则' }}</div>
        <div class="manual-subtitle">配置标签值后，填写匹配逻辑（支持 DSL 表达式）</div>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="ruleRules" label-position="top" size="small">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="ruleForm.ruleName" placeholder="请输入规则名称" :disabled="ruleEditMode"></el-input>
        </el-form-item>

        <!-- 标签值配置 -->
        <div class="section-card">
          <div class="section-title">标签值配置</div>
          <div class="section-tip">配置此规则命中后，需要写入的标签字段值。选填，留空表示不修改该字段。</div>
          <el-form-item label="Role Tag" prop="roleTag">
            <el-input v-model="ruleForm.roleTag" placeholder="请输入 Role Tag" clearable></el-input>
          </el-form-item>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="BU">
                <el-select v-model="ruleForm.bu" placeholder="请选择" clearable filterable style="width: 100%">
                  <el-option v-for="item in options.BU" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Channel">
                <el-select v-model="ruleForm.channel" placeholder="请选择" clearable filterable style="width: 100%">
                  <el-option v-for="item in options.CHANNEL" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="Function Tag">
                <el-select v-model="ruleForm.functionTag" placeholder="请选择" clearable filterable style="width: 100%">
                  <el-option v-for="item in options.FUNCTION_TAG" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Scenario">
                <el-select v-model="ruleForm.scenario" placeholder="请选择" clearable filterable style="width: 100%">
                  <el-option v-for="item in options.SCENARIO" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 规则逻辑配置 -->
        <div class="section-card">
          <div class="section-title">规则逻辑配置</div>
          <div class="section-tip">规则配置 SQL 查询 where 条件</div>
          <el-form-item prop="dslText">
            <div class="sql-editor">
              <div class="sql-editor-bar">
                <span class="sql-where">WHERE</span>
                <span class="sql-fields">可用字段: email · function · orgL1 · orgL2 · orgL3 · orgType · userType · position</span>
              </div>
              <div ref="sqlEditor" class="sql-editor-body"></div>
              <div class="sql-editor-tokens">
                <el-button v-for="t in sqlTokens" :key="t" size="mini" @click="insertSqlToken(t)">{{ t }}</el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="ruleFormVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="ruleSaving" @click="submitRule">{{ ruleEditMode ? '确认保存' : '确认添加' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material-darker.css'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/addon/display/placeholder.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import util from '@/util/util.js'
import { pageSizes, pageSize } from '@/view/BPM/util/util.js'
import breadcrumb from "@/components/breadcrumb";
import permission from '@/directive/permission/index.js'; // 权限判断指令

// 规则 DSL 可用字段（与编辑器顶栏提示一致），输入字母时自动补全
const SQL_FIELDS = ['email', 'function', 'orgL1', 'orgL2', 'orgL3', 'orgType', 'userType', 'position']

export default {
  name: 'UserTagMaintenance',
  components: {
    breadcrumb
  },
  directives: { permission },
  data() {
    return {
      // 列表筛选：与接口 /v1/rrTag/page 的筛选字段一一对应
      filterForm: {
        roleTag: '',
        bu: '',
        channel: '',
        functionTag: '',
        scenario: '',
        nameEn: '',
        email: ''
      },
      options: {
        ROLE_TAG: [],
        BU: [],
        CHANNEL: [],
        FUNCTION_TAG: [],
        SCENARIO: []
      },
      tableData: [],
      total: 0,
      selectedRows: [],
      tableLoading: false,
      pageSizes,
      pageSize,
      pageIndex: 1,
      tabHeight: 0,
      // 导出
      exportLoading: false,
      // 手动打标
      manualDialogVisible: false,
      manualLoading: false,
      manualForm: {
        email: '',
        roleTag: '',
        bu: '',
        channel: '',
        functionTag: '',
        scenario: ''
      },
      manualRules: {
        email: [{ required: true, message: '请输入用户 Email', trigger: 'blur' }],
        roleTag: [{ required: true, message: '请选择 Role Tag', trigger: 'change' }]
      },
      // 导入
      importDialogVisible: false,
      templateLoading: false,
      importLoading: false,
      uploading: false,
      uploadUrl: this.baseSSO.upload_file_url,
      importFile: { fileId: '', fileName: '' },
      // 规则
      ruleDialogVisible: false,
      ruleList: [],
      ruleLoading: false,
      ruleFormVisible: false,
      ruleEditMode: false,
      ruleSaving: false,
      sqlTokens: ['AND', 'OR', 'NOT', 'IN (...)', "LIKE '%.%'", 'IS NULL'],
      ruleForm: {
        id: '',
        ruleName: '',
        roleTag: '',
        enabled: 1,
        bu: '',
        channel: '',
        functionTag: '',
        scenario: '',
        dslText: ''
      },
      ruleRules: {
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        roleTag: [{ required: true, message: '请输入 Role Tag', trigger: 'blur' }],
        dslText: [
          { required: true, message: '请输入规则 DSL', trigger: 'blur' },
          // {
          //   validator: (rule, value, callback) => {
          //     if (value && value.toLowerCase().indexOf('position') === -1) {
          //       callback(new Error('规则逻辑不合法：规则必须包含 position 条件'))
          //     } else {
          //       callback()
          //     }
          //   },
          //   trigger: 'blur'
          // }
        ]
      }
    }
  },
  computed: {
    // 手动打标：仅 config 类型标签
    roleTagConfigOptions() {
      return this.options.ROLE_TAG.filter(item => item.type === 'config')
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
    // CodeMirror 实例不放 data，避免被 Vue 做深度响应式监听
    this.sqlEditor = null
  },
  mounted() {
    this.fetchOptions()
    this.loadTable()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight)
    this.destroySqlEditor()
  },
  methods: {
    // ============ 通用 ============
    // 动态计算表格高度
    getHeight() {
      this.tabHeight = window.innerHeight - 420 + 'px'
    },
    // 兼容响应拦截器：data 为真值时返回信封，否则返回 axios 响应
    normalizeResp(res) {
      if (res && typeof res.success !== 'undefined') {
        return { success: res.success, data: res.data }
      }
      if (res && res.data && typeof res.data.success !== 'undefined') {
        return { success: res.data.success, data: res.data.data }
      }
      return { success: false, data: null }
    },
    // 列表行按 UI 需要补出展示字段；接口 null 字段会缺 key，统一兜底
    mapRow(row) {
      return {
        ...row,
        banner: row.bannerName || row.bannerCode || '',
        category: row.categoryName || row.categoryCode || ''
      }
    },
    // ============ 下拉选项 ============
    fetchOptions() {
      const url = `${this.baseCmrUrl}/v1/rrTag/options`
      this.http.get(url).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success && data) {
          // ROLE_TAG 项结构为 {type, value}：筛选用全量，手动打标取 config，规则维护取 rule（见 computed）
          const roleTag = (data.ROLE_TAG || []).map(item => (typeof item === 'string' ? { type: '', value: item } : item))
          this.options = {
            ROLE_TAG: roleTag,
            BU: data.BU || [],
            CHANNEL: data.CHANNEL || [],
            FUNCTION_TAG: data.FUNCTION_TAG || [],
            SCENARIO: data.SCENARIO || []
          }
        }
      }).catch(() => {})
    },
    // ============ 列表查询 ============
    buildQuery() {
      // 筛选字段名与 /v1/rrTag/page 入参一一对应，无需逐个映射；空值不传
      const q = {}
      Object.keys(this.filterForm).forEach(key => {
        const val = this.filterForm[key]
        if (val !== '' && val !== null && val !== undefined) {
          q[key] = val
        }
      })
      q.pageNum = this.pageIndex
      q.pageSize = this.pageSize
      return q
    },
    loadTable() {
      this.tableLoading = true
      const url = `${this.baseCmrUrl}/v1/rrTag/page`
      this.http.post(url, this.buildQuery()).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success && data) {
          this.tableData = (data.list || []).map(row => this.mapRow(row))
          this.total = data.total || 0
        }
      }).catch(() => {}).finally(() => {
        this.tableLoading = false
      })
    },
    handleQuery() {
      this.pageIndex = 1
      this.loadTable()
    },
    handleCurrentChange(page) {
      this.pageIndex = page
      this.loadTable()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.loadTable()
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    // 仅 MANUAL 行可勾选删除
    checkSelectable(row) {
      return row.tagSource === 'MANUAL'
    },
    // ============ 删除 ============
    handleDelete() {
      if (this.selectedRows.length === 0) return
      const ids = this.selectedRows.map(r => r.id)
      this.$confirm(`确认删除选中的 ${ids.length} 条手工标签数据？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const url = `${this.baseCmrUrl}/v1/rrTag/delete`
        this.http.post(url, { ids }).then(resp => {
          const { success } = this.normalizeResp(resp)
          if (success) {
            this.$message.success('删除成功')
            this.selectedRows = []
            this.loadTable()
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    // ============ 导出 ============
    handleExport() {
      this.exportLoading = true
      const url = `${this.baseCmrUrl}/v1/rrTag/export`
      // 导出全量匹配数据，pageNum / pageSize 对导出无影响
      const body = this.buildQuery()
      delete body.pageNum
      delete body.pageSize
      this.http.post(url, body).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success && data && data.fileUrl) {
          util.triggerDownload(data.fileUrl)
        }
      }).catch(() => {}).finally(() => {
        this.exportLoading = false
      })
    },
    // ============ 手动打标 ============
    openManualDialog() {
      this.manualDialogVisible = true
    },
    // 提交中禁止手动关闭：X / 遮罩 / Esc 都会走 before-close，loading 期间直接吞掉
    manualBeforeClose(done) {
      if (this.manualLoading) return
      done()
    },
    resetManualForm() {
      this.manualForm = {
        email: '', roleTag: '', bu: '', channel: '', functionTag: '', scenario: ''
      }
      if (this.$refs.manualForm) this.$refs.manualForm.resetFields()
    },
    submitManual() {
      this.$refs.manualForm.validate(valid => {
        if (!valid) return
        const email = (this.manualForm.email || '').trim()
        if (!email) {
          this.$message.warning('请输入用户 Email')
          return
        }
        // 接口 emails 为数组，本弹窗为单人打标，包成单元素数组
        const body = {
          emails: [email],
          roleTag: this.manualForm.roleTag
        }
        if (this.manualForm.bu) body.bu = this.manualForm.bu
        if (this.manualForm.channel) body.channel = this.manualForm.channel
        if (this.manualForm.functionTag) body.functionTag = this.manualForm.functionTag
        if (this.manualForm.scenario) body.scenario = this.manualForm.scenario
        this.manualLoading = true
        const url = `${this.baseCmrUrl}/v1/rrTag/manual`
        this.http.post(url, body).then(resp => {
          const { success, data } = this.normalizeResp(resp)
          if (success) {
            this.$message.success(`成功打标 ${data || 0} 人`)
            this.manualDialogVisible = false
            this.loadTable()
          }
        }).catch(() => {}).finally(() => {
          this.manualLoading = false
        })
      })
    },
    // ============ 导入 ============
    openImportDialog() {
      this.resetImport()
      this.importDialogVisible = true
    },
    // 导入提交中禁止关闭：X / Esc 走 before-close（遮罩已由 close-on-click-modal 禁用）
    importBeforeClose(done) {
      if (this.importLoading) return
      done()
    },
    resetImport() {
      this.importFile = { fileId: '', fileName: '' }
    },
    resetImportFile() {
      this.importFile = { fileId: '', fileName: '' }
    },
    beforeUpload(file) {
      const isExcel = /\.(xlsx|xls)$/.test(file.name.toLowerCase())
      if (!isExcel) {
        this.$message.warning('仅支持 .xlsx / .xls 文件')
        return false
      }
      return true
    },
    // util 内部是同步 XHR（会阻塞渲染），先让 loading 渲染一拍再进入上传，结束后复位
    uploadFileRequest(request) {
      this.uploading = true
      setTimeout(() => {
        try {
          util.uploadFileForElementUploadCmr(request, this)
        } finally {
          this.uploading = false
        }
      }, 100)
    },
    // util 上传成功后回调：fileId 取自文件中心响应
    handleSuccess(event, file, fileName) {
      let response
      try {
        response = JSON.parse(event.currentTarget.response)
      } catch (e) {
        this.$message.error('文件上传失败')
        return
      }
      if (event.currentTarget.status === 200 && response.fileId) {
        this.importFile = { fileId: response.fileId, fileName: fileName || file.name }
        this.$message.success('文件上传成功')
      } else {
        this.$message.error('文件上传失败')
      }
    },
    handleError() {
      this.$message.error('文件上传失败')
    },
    handleTemplateDownload() {
      this.templateLoading = true
      const url = `${this.baseCmrUrl}/v1/rrTag/template`
      this.http.get(url).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success && data && data.fileUrl) {
          util.triggerDownload(data.fileUrl)
        }
      }).catch(() => {}).finally(() => {
        this.templateLoading = false
      })
    },
    submitImport() {
      if (!this.importFile.fileId) {
        this.$message.warning('请先上传文件')
        return
      }
      this.importLoading = true
      const url = `${this.baseCmrUrl}/v1/rrTag/import`
      this.http.post(url, {
        fileId: this.importFile.fileId,
        fileName: this.importFile.fileName
      }).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success) {
          this.$message.success(`成功导入 ${data || 0} 行`)
          this.importDialogVisible = false
          this.loadTable()
        }
      }).catch(() => {}).finally(() => {
        this.importLoading = false
      })
    },
    // ============ 规则维护 ============
    openRuleDialog() {
      this.ruleDialogVisible = true
    },
    fetchRules() {
      this.ruleLoading = true
      const url = `${this.baseCmrUrl}/v1/rrTagRule/list`
      this.http.get(url).then(resp => {
        const { success, data } = this.normalizeResp(resp)
        if (success) {
          this.ruleList = data || []
        }
      }).catch(() => {}).finally(() => {
        this.ruleLoading = false
      })
    },
    openRuleForm(row) {
      this.ruleEditMode = !!row
      if (row) {
        this.ruleForm = {
          id: row.id,
          ruleName: row.ruleName,
          roleTag: row.roleTag,
          enabled: row.enabled,
          bu: row.bu || '',
          channel: row.channel || '',
          functionTag: row.functionTag || '',
          scenario: row.scenario || '',
          dslText: row.dslText || ''
        }
      } else {
        this.resetRuleForm()
      }
      this.ruleFormVisible = true
    },
    resetRuleForm() {
      this.ruleForm = {
        id: '', ruleName: '', roleTag: '', enabled: 1,
        bu: '', channel: '', functionTag: '', scenario: '', dslText: ''
      }
      this.destroySqlEditor()
      if (this.$refs.ruleForm) this.$refs.ruleForm.resetFields()
    },
    // ============ SQL 编辑器（CodeMirror） ============
    // 弹窗打开后初始化（el-dialog 内容首次打开才渲染，ref 此时才可用）
    initSqlEditor() {
      if (this.sqlEditor) {
        this.sqlEditor.setValue(this.ruleForm.dslText || '')
        this.$nextTick(() => this.sqlEditor.refresh())
        return
      }
      this.sqlEditor = CodeMirror(this.$refs.sqlEditor, {
        value: this.ruleForm.dslText || '',
        mode: 'text/x-sql',
        theme: 'material-darker',
        lineNumbers: true,
        lineWrapping: true,
        indentUnit: 2,
        tabSize: 2,
        placeholder: "例如：function = 'SLS' AND orgL1 = 'MS&P'"
      })
      this.sqlEditor.on('change', cm => {
        this.ruleForm.dslText = cm.getValue()
      })
      // 输入字母触发字段补全：候选弹层里 Tab / Enter 回填，Esc 关闭
      this.sqlEditor.on('inputRead', (cm, change) => {
        const text = change.text && change.text.join('')
        if (text && /^[A-Za-z_]$/.test(text)) {
          cm.showHint({ hint: this.sqlFieldHint, completeSingle: false })
        }
      })
      this.$nextTick(() => this.sqlEditor.refresh())
    },
    destroySqlEditor() {
      if (!this.sqlEditor) return
      const wrapper = this.sqlEditor.getWrapperElement()
      if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper)
      this.sqlEditor = null
    },
    // 快捷插入 SQL 关键字 / 片段到光标处
    insertSqlToken(token) {
      if (!this.sqlEditor) return
      const doc = this.sqlEditor.getDoc()
      const cursor = doc.getCursor()
      const prefix = cursor.ch > 0 ? ' ' : ''
      doc.replaceRange(prefix + token + ' ', cursor)
      this.sqlEditor.focus()
    },
    // 字段补全提示：按光标处已输入的前缀过滤可用字段
    sqlFieldHint(cm) {
      const cursor = cm.getCursor()
      const line = cm.getLine(cursor.line)
      let start = cursor.ch
      while (start > 0 && /[\w]/.test(line.charAt(start - 1))) start--
      let end = cursor.ch
      while (end < line.length && /[\w]/.test(line.charAt(end))) end++
      const word = line.slice(start, cursor.ch).toLowerCase()
      if (!word) return null
      const list = SQL_FIELDS.filter(f => f.toLowerCase().indexOf(word) === 0)
      if (list.length === 0) return null
      return {
        list,
        from: CodeMirror.Pos(cursor.line, start),
        to: CodeMirror.Pos(cursor.line, end)
      }
    },
    submitRule() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return
        const body = {
          ruleName: this.ruleForm.ruleName,
          roleTag: this.ruleForm.roleTag,
          enabled: this.ruleForm.enabled,
          dslText: this.ruleForm.dslText
        }
        if (this.ruleForm.bu) body.bu = this.ruleForm.bu
        if (this.ruleForm.channel) body.channel = this.ruleForm.channel
        if (this.ruleForm.functionTag) body.functionTag = this.ruleForm.functionTag
        if (this.ruleForm.scenario) body.scenario = this.ruleForm.scenario
        if (this.ruleEditMode) body.id = this.ruleForm.id
        this.ruleSaving = true
        const url = `${this.baseCmrUrl}/v1/rrTagRule/save`
        this.http.post(url, body).then(resp => {
          const { success } = this.normalizeResp(resp)
          if (success) {
            this.$message.success(this.ruleEditMode ? '规则已更新' : '规则已新增')
            this.ruleFormVisible = false
            this.fetchRules()
          }
        }).catch(() => {}).finally(() => {
          this.ruleSaving = false
        })
      })
    },
    toggleRule(row, val) {
      const url = `${this.baseCmrUrl}/v1/rrTagRule/toggle`
      this.http.post(url, { id: row.id, enabled: val }).then(resp => {
        const { success } = this.normalizeResp(resp)
        if (success) {
          row.enabled = val
          this.$message.success(val === 1 ? '已启用' : '已停用')
        } else {
          this.fetchRules()
        }
      }).catch(() => {
        this.fetchRules()
      })
    },
    deleteRule(row) {
      this.$confirm(`确认删除规则「${row.ruleName}」？删除后需等定时任务执行才会移除对应标签。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const url = `${this.baseCmrUrl}/v1/rrTagRule/delete`
        this.http.post(url, { id: row.id }).then(resp => {
          const { success } = this.normalizeResp(resp)
          if (success) {
            this.$message.success('规则已删除')
            this.fetchRules()
          }
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}

.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 12px;
}

// 筛选卡片：左侧控件组 + 右侧按钮组
.filter-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 14px 20px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px 16px;

  // 左侧控件组（自身可换行）
  .filter-items {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 12px 16px;
    flex: 1;
  }

  // 右侧按钮组：margin-top 补偿 label 高度（18px 行高 + 6px 间距），与控件顶行对齐
  .filter-btns {
    flex-shrink: 0;
    margin-top: 24px;
  }

  .filter-item {
    display: flex;
    flex-direction: column;

    .filter-label {
      font-size: 12px;
      line-height: 18px;
      color: #303133;
      font-weight: 700;
      margin-bottom: 6px;
      white-space: nowrap;
    }
  }
}

// 表格卡片：工具栏 + 表格 + 分页
.table-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 14px 16px;

  .table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .total-count {
      font-size: 14px;
      color: #606266;
    }

    .toolbar-left {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .selected-count {
      height: 22px;
      padding: 0 10px;
      border-radius: 11px;
      background-color: #ecf5ff;
      color: #409eff;
      font-size: 12px;
      font-weight: 600;
      line-height: 22px;
    }

    .toolbar-btns {
      display: flex;
    }
  }

  /deep/ .el-table {
    .el-table__header th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 600;
      font-size: 13px;
      padding: 5px 0;
    }

    .el-table__body td {
      font-size: 13px;
      padding: 5px 0;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f0f5ff;
    }
  }
}

// 规则列表删除按钮（弹窗内，独立于表格卡片）
.danger-text {
  color: #f56c6c;
}

// 手动打标弹窗标题
.manual-dialog-title {
  .manual-title {
    font-size: 16px;
    font-weight: 700;
    color: #303133;
    line-height: 22px;
  }

  .manual-subtitle {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #909399;
    line-height: 18px;
  }
}

// 所有弹窗居中显示（覆盖 Element 默认的 margin-top: 15vh）
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/ .el-dialog {
  margin: 0 !important;
}

// 规则相关弹窗：body 限高内部滚动，避免小屏时整页滚动
// 弹层高度 = 15vh(top) + header(~61px) + body + footer(~70px)，body 留 85vh - 170px
/deep/ .rule-dialog .el-dialog__body {
  max-height: calc(85vh - 170px);
  overflow-y: auto;
}

// label 置顶表单：压缩 label 与输入框的间隙
// Element 2.9 的 label-top 未重置基础 line-height（small 下 32px），叠加 10px 下边距导致间隙过大
/deep/ .el-form--label-top .el-form-item__label {
  line-height: 20px;
  padding-bottom: 0;
}

// 批量维护弹窗：三步引导
.import-steps {
  .import-step {
    display: flex;
    align-items: flex-start;

    & + .import-step {
      margin-top: 24px;
    }

    .step-no {
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: #409eff;
      color: #fff;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 12px;
      margin-top: 2px;
    }

    .step-body {
      flex: 1;

      .step-title {
        font-size: 14px;
        font-weight: 700;
        color: #303133;
        line-height: 24px;
      }

      .step-desc {
        font-size: 13px;
        color: #606266;
        line-height: 20px;
        margin: 2px 0 10px;
      }
    }
  }
}

.import-upload {
  margin-bottom: 10px;
}

.uploaded-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #303133;

  .el-icon-close {
    margin-left: auto;
    cursor: pointer;
    color: #909399;
  }

  .el-icon-close:hover {
    color: #f56c6c;
  }
}

// 规则弹窗分区卡片
.section-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 14px 16px 2px;
  margin-bottom: 16px;

  .section-title {
    font-size: 14px;
    font-weight: 700;
    color: #303133;
    line-height: 20px;
    margin-bottom: 4px;
  }

  .section-tip {
    font-size: 12px;
    color: #909399;
    line-height: 18px;
    margin-bottom: 12px;
  }
}

// SQL 编辑器
.sql-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;

  .sql-editor-bar {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #dcdfe6;

    .sql-where {
      font-size: 12px;
      font-weight: 700;
      color: #eb2f96;
      letter-spacing: 0.5px;
      margin-right: 12px;
    }

    .sql-fields {
      font-size: 12px;
      color: #909399;
    }
  }

  /deep/ .CodeMirror {
    height: 180px;
    font-size: 13px;
    font-family: Consolas, Monaco, 'Courier New', monospace;
  }

  .sql-editor-tokens {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px 12px;
    background-color: #fafafa;
    border-top: 1px solid #dcdfe6;

    /deep/ .el-button--mini {
      padding: 5px 10px;
    }
  }
}
</style>

<style lang="scss">
// CodeMirror 补全弹层（show-hint）挂在 document.body 下，scoped 样式作用不到；
// 且其自带样式写死 z-index:10，会被 el-dialog（z-index 2000+）盖住导致弹层不可见，这里抬高到弹窗之上
.CodeMirror-hints {
  z-index: 9999 !important;
}

// 表格 show-overflow-tooltip：限制气泡最大宽度，超长内容（如 organization）换行展示
.el-tooltip__popper {
  max-width: 500px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/view/cmr/user_tag_maintenance.vue